/** `/subscribe` carrying where to come back to once the viewer can watch. */
export const toPaywallPath = returnTo => `/subscribe?returnTo=${encodeURIComponent(returnTo)}`;
